import { render, staticRenderFns } from "./IframePopup.vue?vue&type=template&id=75fd9d19&scoped=true&"
import script from "./IframePopup.vue?vue&type=script&lang=ts&"
export * from "./IframePopup.vue?vue&type=script&lang=ts&"
import style0 from "./IframePopup.vue?vue&type=style&index=0&id=75fd9d19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fd9d19",
  null
  
)

export default component.exports